import { render, staticRenderFns } from "./2PPT.vue?vue&type=template&id=5f35ab51&scoped=true&"
import script from "./2PPT.vue?vue&type=script&lang=js&"
export * from "./2PPT.vue?vue&type=script&lang=js&"
import style0 from "./2PPT.vue?vue&type=style&index=0&id=5f35ab51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35ab51",
  null
  
)

export default component.exports